import * as React from 'react'
// import * as classnames from 'classnames'

import * as styles from './timeline.css'

import { injectStores, StoreComponent } from '../../../store'
import { observer } from 'mobx-react'
import { bind } from 'bind-decorator'
import enhanceWithClickOutside from 'react-click-outside'
import { CloseButtonMobile } from '../../common/elements/buttons'
import { Portal } from 'react-portal'

interface IProps {
  onExpandClick? (): void
  open?: boolean
}

@injectStores
@enhanceWithClickOutside
@observer
export class Timeline extends StoreComponent<IProps> {
  element: HTMLDivElement | null = null

  constructor (props: any, context: any) {
    super(props, context)
    this.store.storyDocContent.fetchTimeline()
  }

  componentDidMount () {
    this.element && this.element.addEventListener('scroll', this.handleTimelineScroll, true)
  }

  @bind
  handleTimelineScroll (e: any) {
    e.stopPropagation()
  }

  handleClickOutside () {
    if (this.props.open && this.props.onExpandClick) this.props.onExpandClick()
  }

  render () {
    let mobileCloseButton: JSX.Element | null = null
    mobileCloseButton = <div className={ styles.closeButton }>
                          <CloseButtonMobile onClick={ this.props.onExpandClick }/>
                        </div>

    let sections: JSX.Element[] = []
    if (this.store.storyDocContent.timeline) {
      for (const section of this.store.storyDocContent.timeline.sections) {
        let sectionYear = this.store.breakpoints.desktop ? section.year.replace(/\s/g, '<br>') : section.year

        let entries: JSX.Element[] = []
        for (const date in section.entries) {
          entries.push(
            <div className={ styles.entryContent } key={ date }>
              <div className={ styles.exactDate }>{ date }</div>
              <div className={ styles.description }>{ section.entries[date] }</div>
            </div>
          )
        }
        sections.push(
            <div className={ styles.overlaySection } key={section.year}>
              <div className={ styles.sectionYears }>
                <div className={ styles.yearsText } dangerouslySetInnerHTML={ { __html: sectionYear } }></div>
              </div>
              <div className={ styles.sectionContent }>{ entries }</div>
            </div>
          )
      }
    }

    let timeline: JSX.Element | null = null
    timeline = <div
                  className={ styles.timeline }
                  ref={ elem => this.element = elem }
                  onScroll={ (e: any) => this.handleTimelineScroll(e) }
                >
                  <div className={ styles.overlayTitle }>{ this.store.storyDocContent.timeline && this.store.storyDocContent.timeline.title }</div>
                  {sections}
                </div>

    if (this.store.breakpoints.desktop) {
      return timeline
    } else {
      return (
        <Portal>
          <div className={ styles.timelineContainer }>
            { this.props.open && mobileCloseButton }
            { this.props.open && timeline }
          </div>
        </Portal>
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/storydoc/drawer/timeline.tsx